'use client';

import { useEffect } from 'react';

// Self-hosted Chatwoot web widget. Set both in .env.local once Chatwoot is deployed:
//   NEXT_PUBLIC_CHATWOOT_BASE_URL       e.g. https://chat.agathos.technology
//   NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN  from Chatwoot → Inboxes → (your website) → Configuration
declare global {
  interface Window {
    chatwootSDK?: {
      run: (config: { websiteToken: string; baseUrl: string }) => void;
    };
    chatwootSettings?: Record<string, unknown>;
  }
}

export default function ChatwootWidget() {
  // Strip any trailing slash so `${baseUrl}/packs/js/sdk.js` never doubles up.
  const baseUrl = process.env.NEXT_PUBLIC_CHATWOOT_BASE_URL?.replace(/\/+$/, '');
  const websiteToken = process.env.NEXT_PUBLIC_CHATWOOT_WEBSITE_TOKEN;

  useEffect(() => {
    if (!baseUrl || !websiteToken) return;
    if (document.getElementById('chatwoot-sdk')) return;

    window.chatwootSettings = {
      position: 'right',
      type: 'standard',
      launcherTitle: 'Chat with us',
    };

    const s = document.createElement('script');
    s.id = 'chatwoot-sdk';
    s.src = `${baseUrl}/packs/js/sdk.js`;
    s.defer = true;
    s.async = true;
    s.onload = () => {
      window.chatwootSDK?.run({ websiteToken, baseUrl });
    };
    document.head.appendChild(s);
  }, [baseUrl, websiteToken]);

  return null;
}
